"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHeader = exports.DialogFooter = exports.DialogBody = exports.Dialog = void 0;
var Dialog_1 = __importDefault(require("./Dialog"));
exports.Dialog = Dialog_1.default;
var DialogBody_1 = __importDefault(require("./DialogBody"));
exports.DialogBody = DialogBody_1.default;
var DialogHeader_1 = __importDefault(require("./DialogHeader"));
exports.DialogHeader = DialogHeader_1.default;
var DialogFooter_1 = __importDefault(require("./DialogFooter"));
exports.DialogFooter = DialogFooter_1.default;
exports.default = { Dialog: Dialog_1.default };
//# sourceMappingURL=index.js.map